export const handleImageRedaction = (
  message: { _id: string; id: string },
  redactionData: string,
) => {
  const redactedText = `Redacted Image - ${message?._id || message?.id}`;
  return {
    ...message,
    isImageRedacted: true,
    body: redactedText,
    redactedBody: redactedText,
    redactionData,
  };
};

export const updateRedactionViewedEvents = (
  currentEvents: unknown[],
  authUser: { _id: string; firstName: string; lastName: string },
) => {
  const newRedactionViewEvent = {
    userId: authUser?._id,
    operatorName: `${authUser?.firstName} ${authUser?.lastName}`,
    eventTime: new Date().getTime(),
  };
  return [...currentEvents, newRedactionViewEvent];
};
